import {
  AiProgressReportContent,
  AiProgressSection,
} from "./aiProgressSummaryTypes";
import {
  parseAiProgressSummaryResponse,
  parseProgressMetric,
  unwrapProgressResponse,
} from "./aiProgressSummaryResponse";

export type AiBloodProgressSummary = AiProgressReportContent & {
  systems: (AiProgressSection & { name: string })[];
};

export const parseAiBloodProgressSummaryResponse = (
  payload: unknown
): AiBloodProgressSummary => {
  const root = unwrapProgressResponse(payload);
  const {
    patient,
    heroPill,
    reportTypes,
    keyTakeaway,
    trainingPlan,
    nutrition,
    recommendations,
    disclaimer,
  } = parseAiProgressSummaryResponse(payload);
  const systems = Array.isArray(root.systems) ? root.systems : [];
  return {
    patient,
    heroPill,
    reportTypes,
    keyTakeaway,
    trainingPlan,
    nutrition,
    recommendations,
    disclaimer,
    systems: systems.flatMap((item) => {
      if (!item || typeof item !== "object" || Array.isArray(item)) return [];
      const source = item as Record<string, unknown>;
      const name =
        typeof source.system === "string" ? source.system.trim() : "";
      const description =
        typeof source.summary === "string" ? source.summary.trim() : "";
      const metrics = (
        Array.isArray(source.biomarkers) ? source.biomarkers : []
      ).flatMap((value) => {
        const metric = parseProgressMetric(value, patient.testDates);
        return metric ? [metric] : [];
      });
      // Server ordering and placement are authoritative, including duplicates across systems.
      return name || description || metrics.length
        ? [{ name, description, metrics }]
        : [];
    }),
  };
};
